<template>
    <div class="chat-initiator-template">
        <div class="header">
            <div class="title">{{ $t("whatsapp_business_api.chatInitiatorTemplate") }}</div>
        </div>
        <div class="title">{{ $t("whatsapp_business_api.selectChatInitiatorTemplate") }}</div>
        <div class="d-flex gap-5">
            <a-select v-model="selectedTemplateId" style="width: 100%" :placeholder="$t('whatsapp_business_api.selectChatInitiatorTemplate')">
                <a-select-option v-for="template in templates" :key="template.id" :value="template.id">
                    {{ template.elementName }}
                </a-select-option>
            </a-select>
            <a-spin v-if="loading">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            </a-spin>
        </div>

        <a-divider />
        <div class="start-template-viewer">
            <TemplateCard :template="selectedTemplate" v-if="!!selectedTemplate" />
            <div class="right">
                <div class="preview-container">
                    <WhatsappMessagePreview
                        :body="getTemplateParameters(selectedTemplate).body"
                        :footer="getTemplateParameters(selectedTemplate).footer"
                        :headerType="getTemplateParameters(selectedTemplate).headerText"
                        :header-text="getTemplateParameters(selectedTemplate).headerText"
                        :buttons="getTemplateParameters(selectedTemplate).buttons"
                        v-if="selectedTemplate"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import TemplateCard from "./TemplateCard.vue";
import log2 from "../../../../utils/log2";
import WhatsappMessagePreview from "../WhatsappMessagePreview.vue";

const log = log2("ChatInitiatorTemplate.vue");
export default Vue.extend({
    name: "ChatInitiatorTemplate",
    components: { WhatsappMessagePreview, TemplateCard },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            selectedTemplateId: this.value?.payload?.initialTemplate?.id,
            selectedTemplate: this.value?.payload?.initialTemplate,
            clone: _.cloneDeep(this.value),
            selectedCustomerGroup: null,
            templates: [],
        };
    },
    computed: {
        ...mapState({
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getChannelTemplates() {
            this.getTemplates(this.value._id).then((templates) => {
                this.templates = templates;
            });
        },
        getTemplateParameters(template) {
            const metaObject = JSON.parse(template.meta);
            const containerMetaObj = JSON.parse(template.containerMeta);
            return {
                headerType: null, //text|image,
                headerMediaType: null, //image|video|document|location,
                headerMediaURL: null,
                headerText: _.get(containerMetaObj, "header"),
                footer: _.get(containerMetaObj, "footer"),
                body: _.get(metaObject, "example") || metaObject.data,
                buttons: _.get(containerMetaObj, "buttons") || template.buttons,
            };
        },
    },
    watch: {
        selectedTemplateId(val) {
            log("selectedTemplateId changed =>", val);
            this.selectedTemplate = this.templates.find((x) => x.id === val);
            this.clone.payload.initialTemplate = this.selectedTemplate;
            this.$emit("input", this.clone);
        },
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.getChannelTemplates();
    },
});
</script>

<style scoped lang="scss">
.chat-initiator-template {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .start-template-viewer {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        .template-card {
            width: calc(100% - 400px) !important;
            max-width: unset !important;
        }

        .right {
            display: flex;
            position: relative;

            .preview-container {
                position: sticky;
                top: 20px;
                max-height: 600px;
            }
        }
    }
}
</style>
